import { t } from './index';

// roomManager / playerLedger keep English reason strings (tests + old clients).
// The UI maps those known phrases to the viewer's locale at display time.

const EXACT = {
  'Only the host can do that': 'error.onlyHost',
  'Room not found. Please check the room code.': 'error.roomNotFoundCode',
  'This game has already ended.': 'error.gameEnded',
  'Name already taken. Please choose a different name.': 'error.nameTaken',
  'Room is full.': 'error.roomFull',
  'Please enter a valid amount': 'error.validAmount',
  'Room not found': 'error.roomNotFound',
  'Only you can sit out of your seat': 'error.onlySitOut',
  'Only you can come back to your seat': 'error.onlyComeBack',
  'Cannot advance stage at this time': 'error.cannotAdvance',
  'Pick another player': 'error.pickAnother',
  'Player not found': 'error.playerNotFound',
  'That player is not at the table': 'error.notAtTable',
  'That player is already connected.': 'error.alreadyConnected',
  'Missing token': 'error.missingToken',
  'Host leaving ends the room': 'error.hostLeavingEnds',
  'That player is still at the table': 'error.stillAtTable',
  'Player already in this game': 'error.alreadyInGame',
  'Missing player': 'error.missingPlayer',
  'Seat not found': 'error.playerNotFound',
  'Please enter a valid amount (e.g., "25.50")': 'error.validAmountExample',
  'Please enter a valid positive amount': 'error.positiveAmount',
  'Could not process rebuy. Please try again.': 'error.couldNotRebuy',
  'Rebuy from your phone is for when you have no chips': 'error.rebuyWhenChipless',
  'That rebuy request is no longer there': 'error.rebuyRequestGone',
  'Only you can request a rebuy for your seat': 'error.onlyRequestRebuy',
  'Only you can cancel your rebuy request': 'error.onlyCancelRebuy',
  'Could not move chips. Please try again.': 'error.couldNotMove',
  'Could not undo that action. Please try again.': 'error.couldNotUndo',
  'Could not make a rejoin link.': 'error.couldNotRejoin',
  'Could not remove. Try again.': 'error.couldNotRemove',
  'Could not save. Try again.': 'error.couldNotSave',
  'Please enter your name': 'error.enterName',
  'Please enter both room code and your name': 'error.enterCodeAndName',
  'Failed to create room. Please try again.': 'error.failedCreate',
  'Need at least 2 players to start the game': 'error.needTwo',
  'Failed to start game. Please try again.': 'error.failedStart',
  'Please enter both blind amounts': 'error.bothBlinds',
  'Enter valid blind amounts': 'error.validBlinds',
  'Small blind must be less than big blind': 'error.sbLessThanBb',
  'Enter 1–180 minutes': 'error.enterMinutes',
  'Invalid currency format. Use format like "10.50" or "10"': 'error.invalidCurrency',
  'Something went wrong. Please try again.': 'error.generic',
};

export function localizeError(message, vars) {
  if (message == null || message === '') return '';
  if (EXACT[message]) return t(EXACT[message], vars);
  const minMatch = String(message).match(/^Please enter an amount of at least (.+)$/);
  if (minMatch) return t('error.minAmount', { amount: minMatch[1] });
  return message;
}

export function nextStageLabel(storedName) {
  const map = {
    Flop: 'game.stage.flop',
    Turn: 'game.stage.turn',
    River: 'game.stage.river',
    Showdown: 'game.stage.showdown',
    'Next Stage': 'game.nextRound',
    'Next round': 'game.nextRound',
  };
  return map[storedName] ? t(map[storedName]) : (storedName || t('game.nextRound'));
}
